var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4 22L11.4333 22C15.1667 22 17.5 20 17.5 16.8L17.5 12.75L10.2083 12.75C9.73 12.75 9.33333 12.41 9.33333 12C9.33333 11.59 9.73 11.25 10.2083 11.25L17.5 11.25V7.2C17.5 4 15.1667 2 11.4333 2L8.41167 2C4.67833 2 2.345 4 2.345 7.2L2.345 16.8C2.33333 20 4.66667 22 8.4 22Z",
    fill: "#0099FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6799 12.75L20.2649 14.82C20.0899 14.97 20.0083 15.16 20.0083 15.35C20.0083 15.54 20.0899 15.74 20.2649 15.88C20.6033 16.17 21.1633 16.17 21.5016 15.88L25.4099 12.53C25.7483 12.24 25.7483 11.76 25.4099 11.47L21.5016 8.12003C21.1633 7.83004 20.6033 7.83004 20.2649 8.12003C19.9266 8.41003 19.9266 8.89004 20.2649 9.18004L22.6799 11.25L17.4999 11.25V12.75L22.6799 12.75Z",
    fill: "#0099FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.36368488134cdf72fc8e575e1e727e6a.svg";
export { ForwardRef as ReactComponent };